export const MapSearch = Object.freeze({
  CALENDAR: 0,
  USER: 1
})

export const UserCriticalEventConfirmation = Object.freeze({
  UNKNOWN: -1,
  IGNORE: 0,
  REJECT: 1,
  APPROVE: 2,
  RETRAIN: 3,
  APPROVED_RETRAIN: 4 // not used, actually
})

export const UserFeedbackDangerousState = Object.freeze({
  UNKNOWN: -1,
  DROWSINESS: 0,
  AGGRESSIVENESS: 1
})

export const ComponentMode = Object.freeze({
  CREATE: 'create',
  EDIT: 'edit',
  REMOVE: 'remove'
})

export const UserProfileType = Object.freeze({
  AUTH: 'auth',
  BASIC: 'basic'
})

export const DangerousState = Object.freeze({
  UNKNOWN: 'Unknown danger',
  DISTRACTION: 'distraction',
  DISTRACTION_NO_FACE: 'distraction_no_face',
  DISTRACTION_NO_ATTENTION: 'distraction_no_attention',
  DROWSINESS: 'drowsiness',
  BELT_NOT_FASTEN: 'belt_not_fasten',
  YAWNING: 'yawning',
  CAMERA_SABOTAGE: 'camera_sabotage',
  CAMERA_OFF: 'camera_off',
  CELLPHONE_USE: 'cellphone_use',
  EATING: 'eating',
  SMOKING: 'smoking'
})

export const RetrainingState = Object.freeze({
  DISTRACTION: DangerousState.DISTRACTION,
  DROWSINESS: DangerousState.DROWSINESS,
  EATING: DangerousState.EATING,
  BELT_NOT_FASTEN: DangerousState.BELT_NOT_FASTEN,
  CAMERA_SABOTAGE: DangerousState.CAMERA_SABOTAGE,
  SMOKING: DangerousState.SMOKING,
  CELLPHONE_USE: DangerousState.CELLPHONE_USE
})

export const UserCriticalEventRejection = Object.freeze({
  BUG: 'bug',
  SCRATCH: 'scratch',
  AUDIO_PANEL: 'audio_panel',
  ERROR: 'error',
  SUN_GLARE: 'sun_glare',
  RETRAIN: 'retrain',
  BLINK: 'blink',
  GLASSES: 'glasses',
  OTHER: 'other'
})

export const CriticalEventsDB = Object.freeze({
  DISTRACTION: 'distraction_count',
  DROWSINESS: 'drowsiness_count',
  BELT_NOT_FASTEN: 'nobelt_count',
  CAMERA_SABOTAGE: 'camera_sabotage',
  CAMERA_OFF: 'camera_off',
  CELLPHONE_USE: 'cellphone_use',
  EATING: 'eating_count',
  SMOKING: 'smoking_count'
})

export const RecommendationType = Object.freeze({
  DRINK_COFFEE_CAFE: 'drink_coffee_cafe',
  DRINK_COFFEE_HOTEL: 'drink_coffee_hotel',
  RADIO_AND_MUSIC_ON: 'radio_and_music_on',
  RADIO_AND_MUSIC_OFF: 'radio_and_music_off',
  TALK_WITH_PASSENGERS: 'talk_with_passengers',
  NO_TALK_WITH_PASSENGERS: 'no_talk_with_passengers',
  CONCENTRATE_ON_ROAD: 'concentrate_on_road',
  COOL_CAR_INTERIOR: 'cool_car_interior',
  SING_YOURSELF: 'sing_yourself',
  PULL_OVER: 'pull_over',
  ADJUST_CABIN_LIGHTNING: 'adjust_cabin_lightning',
  STOP_NEXT_REST_AREA: 'stop_next_rest_area',
  CHANGE_DRIVERS: 'change_drivers',
  STOP_STRETCH_EXCERSIZE: 'stop_stretch_excersize',
  ADJUST_SEAT_POSITION: 'adjust_seat_position'
})

export const ReportType = Object.freeze({
  DETAILS: 'details',
  SUMMARY: 'summary'
})

export const SyncDialogStates = Object.freeze({
  SINGLE: 'single',
  SELECTED: 'selected',
  ALL: 'all'
})

// backend part

export const BackendEndpoints = Object.freeze({
  MAP_DRIVERS: 'map/drivers',
  MAP_TRAVEL: 'map/travel',
  MAP_TRAVEL_ADDITIONAL_STATISTICS: 'map/travel_additional_statistics',
  MAP_TRIP_ROAD_POINTS: 'map/trip_road_points',
  MAP_CRITICAL_ADDITIONAL_STATISTICS: 'map/critical_additional_statistics',
  MAP_DRIVER_PROFILE: 'map/driver_profile',
  MAP_DRIVER_TRIPS: 'map/driver_trips',
  MAP_USER_FEEDBACK: 'map/user_feedback',
  MAP_CHECK_CRITICAL_VIDEO: 'map/check_critical_video',
  MAP_CHECK_CRITICAL_VIDEO_FPS: 'map/critical_video_fps',
  MAP_CRITICAL_EVENT_CONFIRMATION: 'map/critical_event_confirmation',
  MAP_SET_ALL_CAMERA_CORRECT_TRIP: 'map/set_all_camera_correct_trip',
  MAP_SET_ALL_MASK_WEARING_TRIP: 'map/set_all_mask_wearing_trip',
  MAP_SET_TRIP_REPORT_STATUS: 'map/set_trip_report_status',
  REQUESTS_SEND_SERVER_REQUEST: 'requests/send_server_request',
  REQUESTS_FETCH_FILE_DATA: 'requests/fetch_file_data',
  REQUESTS_GET_CLIENT_DATA: 'requests/get_client_file',
  REQUESTS_DATATABLE: 'requests/requests_datatable',
  SETTINGS_FETCH_DEFAULT: 'settings/fetch_default',
  SETTINGS_SET_DEFAULT: 'settings/set_default',
  MAP_SET_DRIVER_PROFILE: 'map/set_driver_profile',
  SETTINGS_SYNC_DRIVERS: 'settings/sync_drivers',
  MAP_NANO_DRIVER_LIST: 'map/nano_driver_list',
  MAP_DRIVER_LIST: 'map/driver_list',
  MAP_REQUEST_STATISTICS: 'map/request_statistics',
  MAP_LOAD_CRITICAL_ARCHIVE: 'map/load_critical_archive',
  SET_CRITICAL_DATASET_ENTRY: 'map/set_critical_dataset_entry',
  CHECK_CRITICAL_SLIDE: 'map/check_critical_slides',
  GET_CRITICAL_SLIDE: 'map/get_critical_slide',
  GET_CAR_PARKS: 'map/get_car_parks',
  EDIT_CAR_PARK: 'map/edit_car_park',
  REMOVE_CAR_PARK: 'map/remove_car_park',
  EDIT_CAR_PARK_DRIVER: 'map/edit_car_park_driver',
  REMOVE_CAR_PARK_DRIVER: 'map/remove_car_park_driver',
  SEARCH_CAR_PARK_DRIVERS: 'map/search_car_park_drivers',
  CHARTS_LOAD_CRITICAL_EVENTS: 'charts/critical_events',
  CHARTS_LOAD_CRITICAL_EVENTS_DOUGHNUT: 'charts/critical_events_doughnut',
  CHARTS_LOAD_DRIVERS: 'charts/load_drivers',
  DEMO_VIDEOS: 'map/demo_videos',
  REPORTS_LOAD_SUMMARY: 'reports/summary_report',
  REPORTS_SLIDES_ARCHIVE: 'reports/critical_slides_archive',
  REPORTS_LOAD_CRITICAL_DATASET: 'reports/critical_dataset_report',
  DATASET_LOAD_DATA: 'dataset/fetch_data',
  PAPERS: 'papers',
  USER_PROFILE: 'user_profile',
  RUSAVIC_VIDEO_LIST: 'rusavic',
  GOOGLE_LOGIN: 'login/check-google',
  GOOGLE_LOGOUT: 'logout'
})

export const BackendErrorCodes = Object.freeze({
  INTERNAL_ERROR: 0,
  DATA_MISSING: 1,
  PERMISSION_DENIED: 2,
  USER_ID_NOT_FOUND: 3,
  ENTITY_NOT_FOUND: 4,
  INVALID_SCHEMA_MODEL: 5,
  MESSAGE_DECRYPT_FAIL: 6
})

export const CriticalVideoType = Object.freeze({
  DEMO: 'is_demo',
  DATASET: 'is_dataset'
})

export const criticalPopupMode = Object.freeze({
  MAP: 'map',
  DATASET: 'dataset'
})

export const settingsType = Object.freeze({
  GENERAL: 'general',
  VIDEO: 'video'
})

// critical dataset
export const HumanEntrySex = Object.freeze({
  MALE: 'male',
  FEMALE: 'female'
})

export const HumanEntryWearingType = Object.freeze({
  SINGLE_COLORED: 'single_colored',
  PICTURED_CLOTHES: 'pictured_clothes',
  STRIPED_CLOTHES: 'striped_clothes',
  PLAID_CLOTHES: 'plaid_clothes', // клетчатые вещи
  OTHER_CLOTHES: 'other_clothes'
})

export const HumanEntryGlasses = Object.freeze({
  NONE: 'none',
  NORMAL: 'normal',
  BLACK: 'black'
})

export const HumanEntryHair = Object.freeze({
  SHORT: 'short',
  LONG_HIDING: 'long_hiding'
})

export const LightConditionsType = Object.freeze({
  DAY_TIME: 'day_time',
  NIGHT_TIME: 'night_time',
  GLARE: 'glare',
  DUSK: 'dusk'
})

export const LightConditionsSun = Object.freeze({
  NONE: 'none',
  LEFT: 'left',
  RIGHT: 'right',
  BEHIND: 'behind',
  FRONT: 'front'
})

export const DetectorDirection = Object.freeze({
  NONE: 'none',
  LEFT: 'left',
  RIGHT: 'right'
})

export const DetectorFoodEat = Object.freeze({
  NONE: 'none',
  FRUIT: 'fruit',
  SANDWICH: 'sandwich',
  SMALL_FOOD: 'small_food',
  OTHER: 'other'
})

export const DetectorFoodDrink = Object.freeze({
  NONE: 'none',
  BOTTLE: 'bottle',
  GLASS: 'glass',
  CUP: 'cup',
  OTHER: 'other'
})

export const DetectorSmokeDirection = Object.freeze({
  NONE: 'none',
  LEFT_HAND: 'left_hand',
  RIGHT_HAND: 'right_hand',
  MOUTH: 'mouth'
})

export const CriticalDatasetLabels = Object.freeze({
  SLIDES: 'slides',
  HUMAN: 'human',
  LIGHT_CONDITIONS: 'lightConditions',
  ACTIONS: 'actions',
  DETECTORS: 'detectors',
  BELT_DETECTOR: 'belt_detector',
  FRAME_HANDS_DETECTOR: 'frame_hands_detector',
  PHONE_DETECTOR: 'phone_detector',
  FOOD_DETECTOR: 'food_detector',
  SMOKE_DETECTOR: 'smoke_detector'
})

// syncSlider
export const syncSliderMode = Object.freeze({
  PLAY: 'play',
  STOP: 'stop'
})

// upload video types
export const UploadVideoTypes = Object.freeze({
  DRIVER: 'driver',
  ROAD: 'road'
})

// server requests
export const ServerRequestType = Object.freeze({
  FILE_LIST: 'file_list',
  FILE_UPLOAD: 'file_upload'
})

export const ClientFileStatus = Object.freeze({
  INCOMPLETE: 'incomplete',
  REQUESTED: 'requested',
  SAVED: 'saved',
  LOST: 'lost'
})

export const ClientFileType = Object.freeze({
  LOG: 'log',
  VIDEO: 'video'
})

export const ClientFileInnerType = Object.freeze({
  DASHCAM_DRIVER: 'dashcam_driver',
  DASHCAM_ROAD: 'dashcam_road',
  CRITICAL_VID_DRIVER: 'critical_vid_driver',
  CRITICAL_VID_ROAD: 'critical_vid_road',
  LOGS_APP_PURE: 'logs_app_pure',
  LOGS_APP_ARCHIVE: 'logs_app_archive',
  LOGS_SYSTEM: 'logs_system',
  null: 'null'
})

export const ClientFilesLocalVideoInnerType = Object.freeze({
  DASHCAM_DRIVER: 'dashcam_driver',
  DASHCAM_ROAD: 'dashcam_road',
  CRITICAL_VID_DRIVER: 'critical_vid_driver',
  CRITICAL_VID_ROAD: 'critical_vid_road',
  null: 'null'
})

export const ClientFilesLocalLogsInnerType = Object.freeze({
  LOGS_APP_PURE: 'logs_app_pure',
  LOGS_APP_ARCHIVE: 'logs_app_archive',
  LOGS_SYSTEM: 'logs_system',
  null: 'null'
})

// car parks
export const carParkRole = Object.freeze({
  DRIVER: 0,
  MANAGER: 1
})

// rusavic
export const RusavicCategories = Object.freeze({
  ALL_ROUTE: 'all_route',
  RESET_ROUTE: 'reset_route',
  GAS_STATION: 'gas_station',
  ROUTE_DURATION: 'route_duration',
  ROUTE_ESTIMATION: 'route_estimation',
  TRAFFIC_OVERALL: 'traffic_overall',
  JAM_SITUATION: 'jam_situation',
  JAM_DURATION: 'jam_duration',
  GAS_STATION_SEARCH: 'gas_station_search',
  STREET: 'street',
  HOME_REDIRECTION: 'home_redirection',
  LOCATE_NEAREST: 'locate_nearest',
  GASOLINE_PRICE: 'gasoline_price',
  MUSIC_TURN_ON: 'music_turn_on',
  RADIO_TURN_ON: 'radio_turn_on',
  AUDIOBOOK_TURN_ON: 'audiobook_turn_on',
  MUSIC_TURN_OFF: 'music_turn_off',
  SHUT_UP: 'shut_up',
  CALL_NUMBER: 'call_number',
  SEND_MESSAGE: 'send_message',
  SEND_EMAIL: 'send_email',
  ANSWER_CALL: 'answer_call',
  DECLINE_CALL: 'decline_call',
  BRIGHTNESS_INCREASE: 'brightness_increase',
  BRIGHTNESS_DECREASE: 'brightness_decrease',
  VOLUME_INCREASE: 'volume_increase',
  VOLUME_DECREASE: 'volume_decrease',
  TEMPERATURE_OUTSIDE: 'temperature_outside',
  ROUTE_CREATION: 'route_creation',
  AVOID_JAMS: 'avoid_jams',
  STREET_SEARCH: 'street_search',
  RESTAURANT_SEARCH: 'restaurant_search',
  SET_TIMER: 'set_timer',
  WI_FI_TURN_ON: 'wi_fi_turn_on',
  PLAY_LIST_TURN_ON: 'play_list_turn_on',
  PARKING_SHOW: 'parking_show',
  PARKING_SEARCH: 'parking_search',
  ACCIDENT_AHEAD: 'accident_ahead',
  CALENDAR_SHOW: 'calendar_show',
  REBOOT: 'reboot',
  MASSAGE_BACK: 'massage_back',
  SUSPENSION_SOFT: 'suspension_soft',
  LEAVING_RUNAWAY_WARNING_TURN_OFF: 'leaving_runaway_warning_turn_off',
  INTERIOR_LIGHT_TURN_ON: 'interior_light_turn_on',
  INTERIOR_LIGHT_TURN_OFF: 'interior_light_turn_off',
  AIR_CONDITIONER_TURN_ON: 'air_conditioner_turn_on',
  AIR_CONDITIONER_TURN_OFF: 'air_conditioner_turn_off',
  HEATING_TURN_ON: 'heating_turn_on',
  HEATING_TURN_OFF: 'heating_turn_off',
  SIGNALING_TURN_ON: 'signaling_turn_on'
})
